/* @flow */

import React, { Component } from 'react';
import Config from './config';


export default class DatePicker extends Component {
  render() {
    var date = this.props.date || Config.defaultDate;
    var onClick = this.props.onClick;
    var datePicker = Config.dates.map(function (item) {
      var className = (date === item.name) ? "btn btn-info btn-lg" : "btn btn-default btn-lg";
      return <div key={item.name} className={className} onClick={onClick.bind(this, item)}>{item.name}</div>;
    })
    return (
      <div className="DatePicker">
          {datePicker}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/datePicker.js
 **/